import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import * as pdfjsLib from "pdfjs-dist";
import pdfjsWorker from "pdfjs-dist/build/pdf.worker.min.mjs?url";
import App from "./App.js";
import { AppErrorBoundary } from "./components/AppErrorBoundary";

// Use real PDF.js worker for better performance (avoids "Setting up fake worker" warning)
pdfjsLib.GlobalWorkerOptions.workerSrc = pdfjsWorker;

createRoot(document.getElementById("root")).render(
  <StrictMode>
    <AppErrorBoundary>
      <App />
    </AppErrorBoundary>
  </StrictMode>
);
